import { TFunction } from '@gem/modules/i18n';

import {
  TSystemMessageTextHandler,
  ISystemMessageText,
  ISystemMessageTextPresenter,
} from '../useSystemMessageText.types';

export const chatLeftHandler: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  return {
    html: t('notification_user_left_chat', {
      0: `<span class="system-message-title">${presenter.initiatorDisplayName}</span>`,
      interpolation: { escapeValue: false },
    }),
    sourceText: t('notification_user_left_chat'),
    params: {
      '{0}': { text: presenter.initiatorDisplayName, userId: presenter.initiator?.id },
    },
  };
};
